import { MathUtils, RepeatWrapping, SphereGeometry, TextureLoader, Vector3 } from 'three';
import skyVertex from './SkyVertexNew.glsl';
import skyFragment from './SkyFragmentNew.glsl';
import * as dat from 'dat.gui';
import { assignDeep, isMobile, resourcesFolder, threeJsVariables } from '../../../../settings';
import { Sky } from 'three/examples/jsm/objects/Sky';
import { OrbitDayAndNight } from '../OrbitDayAndNight';

// const DEFAULT_SETTINGS = {
//     debug: false,
// };
//

let dayHeight =      0.28;
let sunriseHeight =  0.10;
let nightHeight =   -0.45;
const orbitSkyConfig = {  ////////////////  Day        Sunrise    Night      Min gui    Max gui    Step gui
    'cloudy':             OrbitSkyProperty( 0.26,      0.03,      0.0,       0.0,       1.0,       0.01     ),
    'cld1':               OrbitSkyProperty( 0.48,      0.08,      0.0,       0.0,       1.0,       0.01     ),
    'cld2':               OrbitSkyProperty( 0.66,      0.12,      0.0,       0.0,       1.0,       0.01     ),
    'rainmulti':          OrbitSkyProperty( 8.0,       0.0,       8.0,       0.0,       30.0,      0.1      ),
    'RAINBOW_BRIGHTNESS': OrbitSkyProperty( 0.0,       0.0,       0.0,       0.0,       1.0,       0.01     ),
    'xAxisWind':          OrbitSkyProperty(-100.0,    -100.0,    -100.0,    -1000.0,    1000.0,    10.0     ),
    'yAxisWind':          OrbitSkyProperty( 160.0,     100.0,     160.0,    -1000.0,    1000.0,    10.0     ),
    'zAxisWind':          OrbitSkyProperty( 250.0,     250.0,     250.0,    -1000.0,    1000.0,    10.0     ),
    'Dfact':              OrbitSkyProperty( 0.15,      0.15,      0.15,      0.0,       1.0,       0.01     ),
    'camera_height':      OrbitSkyProperty( 184.4,     184.4,     184.4,    -1000.0,    1000.0,    0.1      ),
    'Minmu':              OrbitSkyProperty( 0.96,      0.96,      0.96,      0.0,       1.0,       0.01     ),
    'sunSharp':           OrbitSkyProperty( 2.64,      14.24,     1.0,       0.0,       20.0,      0.01     ),
    'sunSize':            OrbitSkyProperty( 0.0,      -0.0009,    0.0,      -0.01,      0.01,      0.0001   ),
    'scatter_steps':      OrbitSkyProperty( 3,         3,         3,         0,         32,        1        ),
    'scatter_steps2':     OrbitSkyProperty( 2,         2,         2,         0,         32,        1        ),
    'Rm':                 OrbitSkyProperty( 120.0,     120.0,     120.0,     0.0,       10000.0,   1        ),
    'rr':                 OrbitSkyProperty( 50.0,      130.0,     248.2,     0.0,       1000.0,    0.1      ),
    'rg':                 OrbitSkyProperty( 80.0,      200.0,     239.3,     0.0,       1000.0,    0.1      ),
    'rb':                 OrbitSkyProperty( 200.0,     290.0,     132.2,     0.0,       1000.0,    0.1      ),
    'bc':                 OrbitSkyProperty( 51.0,      47.7,      51.0,      20.0,      100.0,     0.1      ),
    'bm':                 OrbitSkyProperty( 51.0,      51.0,      51.0,      20.0,      100.0,     0.1      ),
    'by':                 OrbitSkyProperty( 47.6,      49.1,      51.0,      20.0,      100.0,     0.1      ),
    'haze':               OrbitSkyProperty( 0.00,      0.00,      0.00,      0.0,       1.0,       0.01     ),
    'g0':                 OrbitSkyProperty( 0.43,      0.88,      0.17,      0.0,       1.0,       0.01     ),
    'g0min':              OrbitSkyProperty( 0.24,      0.24,      0.1,       0.0,       1.0,       0.01     ),
    'RI0':                OrbitSkyProperty( 36.8,      36.8,      36.8,      0.0,       100.0,     0.1      ),
    'SI':                 OrbitSkyProperty( 7.0,       15.0,      11.0,      0.0,       100.0,     0.1      ),
    'Mmin':               OrbitSkyProperty( 3017.0,    8104.0,    2000.0,    0.0,       10000.0,   1        ),
    'MI0':                OrbitSkyProperty( 8.0,       18.0,      4.9,       0.0,       100.0,     0.1      ),
    'MIMin1':             OrbitSkyProperty( 8.0,       8.0,       8.0,       0.0,       100.0,     0.1      ),
    'tonemap':            OrbitSkyProperty( 0.0,       0.0,       0.0,       0.0,       16.0,      1        ),
    'sat':                OrbitSkyProperty( 1.54,      1.54,      1.51,      0.0,       2.0,       0.01     ),
    'vib':                OrbitSkyProperty( 1.0,       1.0,       1.0,       0.0,       1.0,       0.01     ),
    'hue':                OrbitSkyProperty( 0.0,       0.0,       0.0,       0.0,       1.0,       0.01     ),
    'raleighgam':         OrbitSkyProperty( 2.2,       2.2,       2.2,       0.0,       5.0,       0.01     ),
    'miegam':             OrbitSkyProperty( 1.6,       1.6,       1.6,       0.0,       5.0,       0.01     ),
    'raleighgammin':      OrbitSkyProperty( 0.09,      0.09,      0.09,      0.0,       5.0,       0.01     ),
    'miegamin':           OrbitSkyProperty( 1.41,      1.41,      1.41,      0.0,       5.0,       0.01     ),
    'RRMin':              OrbitSkyProperty( 0.0000000, 0.0000000, 0.0000000, 0.0000000, 0.0001000, 0.0000001),
    'moonillumination':   OrbitSkyProperty( 1.0,       1.0,       1.0,       0.0,       10.0,      0.01     ),
    'moonradius':         OrbitSkyProperty( 0.032,     0.032,     0.032,     0.0,       0.100,     0.0001   ),
    'moonfade':           OrbitSkyProperty( 0.004,     0.004,     0.004,     0.0,       0.010,     0.0001   ),
    'moonpattern':        OrbitSkyProperty( 11.5,      11.5,      11.5,      0.0,       50.0,      0.01     ),
};
const ratioFactor = {
    'rr':    10000000,
    'rg':    10000000,
    'rb':    10000000,
    'bc':    1000000,
    'bm':    1000000,
    'by':    1000000,
    'RRMin': 10000000,
};

export class OrbitSky extends Sky {

    static #debug = config.features.dayNight?.debug || false;

    constructor (params = {}) {
        // console.warn('OrbitSky',params);
        const {clouds, sky} = config.features.dayNight.settings;
        const sunPosition = OrbitDayAndNight.scope?.points?.length > 0
            ? OrbitDayAndNight.scope?.points[0].clone()
            : new Vector3(0,100,100);
        const useTime = params.useTime || false;
        const textureLoader = new TextureLoader();
        const iChannel0 = textureLoader.load('../../../../assets/clouds/iChannel0.png');
        iChannel0.wrapS = RepeatWrapping;
        iChannel0.wrapT = RepeatWrapping;
        iChannel0.flipY = false;
        const iChannel1 = textureLoader.load('../../../../assets/clouds/iChannel1.jpg');
        iChannel1.wrapS = RepeatWrapping;
        iChannel1.wrapT = RepeatWrapping;
        
        Sky.SkyShader.uniforms = {
            'uTime':        { value: 0.0         },
            'sunPosition':  { value: sunPosition },
            'iChannel0':    { value: iChannel0   },
            'iChannel1':    { value: iChannel1   },
            'cloudsCover': { value: 0.0 },
            'cloudsAlpha': { value: 0.0 },
            'showClouds':   { value: false },
            // 'stars':       { value: 0.0         },
        };

        Object.entries(orbitSkyConfig).forEach(([uniform,value]) => {
            Sky.SkyShader.uniforms[uniform] = { value: value.dayValue };
        });

        Sky.SkyShader.vertexShader = skyVertex;
        Sky.SkyShader.fragmentShader = skyFragment;

        super();
        this.mergeParams(params);

        const scale = sky?.scale || 3000;
        this.material.transparent = true;
        this.material.needsUpdate = true;
        this.geometry = new SphereGeometry(1,64,64);
        this.scale.setScalar(scale);

        this.dayConfig = {};
        this.sunriseConfig = {};
        this.nightConfig = {};
        this.sunHeights = { dayHeight, sunriseHeight, nightHeight };

        for (var uniform in orbitSkyConfig) {
            this.dayConfig[uniform] = orbitSkyConfig[uniform].dayValue;
            this.sunriseConfig[uniform] = orbitSkyConfig[uniform].sunriseValue;
            this.nightConfig[uniform] = orbitSkyConfig[uniform].nightValue;
        }
        
        this.updateUniforms();

        this.updateUniforms();

        if (OrbitSky.#debug) {
            this.debug();
        }
    }

    mergeParams(params) {
        dayHeight = params.hasOwnProperty('dayHeight') ? params.dayHeight : dayHeight;
        sunriseHeight = params.hasOwnProperty('sunriseHeight') ? params.sunriseHeight : sunriseHeight;
        nightHeight = params.hasOwnProperty('nightHeight') ? params.nightHeight : nightHeight;
        Object.entries(orbitSkyConfig).forEach(([uniform,value]) => {
            if (params.hasOwnProperty(uniform)) {
                value.dayValue = params[uniform][0];
                value.sunriseValue = params[uniform][1];
                value.nightValue = params[uniform][2];
            }
        });
    }

    debug() {
        this.guiDay = new dat.GUI();
        this.guiDay.width = 300;
        this.guiDay.domElement.style.position = 'absolute';
        this.guiDay.domElement.style.left = '0px';
        this.guiDay.domElement.style.top = '0';
        const dayFolder = this.guiDay.addFolder('Day');
        dayFolder.add(this.sunHeights, 'dayHeight', -1, 1, 0.01).onChange(this.updateUniforms.bind(this));

        this.guiSunrise = new dat.GUI();
        this.guiSunrise.width = 300;
        this.guiSunrise.domElement.style.position = 'absolute';
        this.guiSunrise.domElement.style.left = '310px';
        this.guiSunrise.domElement.style.top = '0';
        const sunriseFolder = this.guiSunrise.addFolder('Sunrise');
        sunriseFolder.add(this.sunHeights, 'sunriseHeight', -1, 1, 0.01).onChange(this.updateUniforms.bind(this));

        this.guiNight = new dat.GUI();
        this.guiNight.width = 300;
        this.guiNight.domElement.style.position = 'absolute';
        this.guiNight.domElement.style.left = '620px';
        this.guiNight.domElement.style.top = '0';
        const nightFolder = this.guiNight.addFolder('Night');
        nightFolder.add(this.sunHeights, 'nightHeight', -1, 1, 0.01).onChange(this.updateUniforms.bind(this));

        for (var uniform in orbitSkyConfig) {
            dayFolder.add(
                this.dayConfig, uniform,
                orbitSkyConfig[uniform].min,
                orbitSkyConfig[uniform].max,
                orbitSkyConfig[uniform].step
            ).onChange(this.updateUniforms.bind(this));
            sunriseFolder.add(
                this.sunriseConfig, uniform,
                orbitSkyConfig[uniform].min,
                orbitSkyConfig[uniform].max,
                orbitSkyConfig[uniform].step
            ).onChange(this.updateUniforms.bind(this));
            nightFolder.add(
                this.nightConfig, uniform,
                orbitSkyConfig[uniform].min,
                orbitSkyConfig[uniform].max,
                orbitSkyConfig[uniform].step
            ).onChange(this.updateUniforms.bind(this));
        }
    }

    updateUniforms() {
        const sunHeight = this.material.uniforms['sunPosition'].value.clone().normalize().y;
        // console.warn('updateUniforms',sunHeight);
        let func = null;
        let factor = null;
        let ratio = null;

        (sunHeight < this.sunHeights.nightHeight) ?
            func = this.#nightValue.bind(this) :
        (sunHeight < this.sunHeights.sunriseHeight) ? (
            func = this.#beforeSunriseValue.bind(this),
            factor = (sunHeight - this.sunHeights.nightHeight) / (this.sunHeights.sunriseHeight - this.sunHeights.nightHeight)) :
        (sunHeight < this.sunHeights.dayHeight) ? (
            func = this.#afterSunriseValue.bind(this),
            factor = (sunHeight - this.sunHeights.sunriseHeight) / (this.sunHeights.dayHeight - this.sunHeights.sunriseHeight)) :
        func = this.#dayValue.bind(this);

        for (var uniform in orbitSkyConfig) {
            ratio = ratioFactor[uniform] || 1;
            this.material.uniforms[uniform] = { value: func(uniform, factor) / ratio };
        }
    }

    #nightValue(uniform) {
        return this.nightConfig[uniform];
    }

    #beforeSunriseValue(uniform, factor) {
        return MathUtils.lerp(this.nightConfig[uniform], this.sunriseConfig[uniform], factor);
    }

    #afterSunriseValue(uniform, factor) {
        return MathUtils.lerp(this.sunriseConfig[uniform], this.dayConfig[uniform], factor);
    }

    #dayValue(uniform) {
        return this.dayConfig[uniform];
    }
}

function OrbitSkyProperty(dayValue, sunriseValue, nightValue, min, max, step) {
    sunriseValue = sunriseValue || dayValue;
    nightValue = nightValue || dayValue;
    return { dayValue, sunriseValue, nightValue, min, max, step }
};
